export enum tipoMapaEnum {
    MAPA_TIPO_CALLEJERO = 'ROADMAP',
    MAPA_TIPO_SATELITE = 'SATELLITE',
    MAPA_TIPO_TERRENO = 'TERRAIN',
    MAPA_TIPO_COMBINADO = 'HYBRID',
  }
  
  export enum tipoEfectoMarcadorEnum {
    MAPA_MARCADOR_EFECTO_FIJO =   '',
    MAPA_MARCADOR_EFECTO_CAIDA = 'DROP',
    MAPA_MARCADOR_EFECTO_BOTE = 'BOUNCE',
  }
  
  
  export enum tiposEstilosEnum {
    TODOS = 'all',
    DIBUJO = 'geometry',
    DIBUJO_CONTENIDO =  'geometry.fill',
    DIBUJO_TRAZO = 'geometry.stroke',
    ETIQUETA = 'labels',
    ETIQUETA_ICONO = 'labels.icon',
    ETIQUETA_TEXTO = 'labels.text',
    ETIQUETA_TEXTO_CONTENIDO = 'labels.text.fill',
    ETIQUETA_TEXTO_TRAZO = 'labels.text.stroke',
  }
  
  export enum estilosElementoEnum {
    MAPA_ESTILOS_ELEMENTO_TODOS = 'all',
    MAPA_ESTILOS_ELEMENTO_POLITICO =  'administrative',
    MAPA_ESTILOS_ELEMENTO_POLITICO_PAIS = 'administrative.country',
    MAPA_ESTILOS_ELEMENTO_POLITICO_PARCELA = 'administrative.land_parcel',
    MAPA_ESTILOS_ELEMENTO_POLITICO_LOCALIDAD = 'administrative.locality',
    MAPA_ESTILOS_ELEMENTO_POLITICO_BARRIO = 'administrative.neighborhood',
    MAPA_ESTILOS_ELEMENTO_POLITICO_PROVINCIA = 'administrative.province',
    MAPA_ESTILOS_ELEMENTO_TERRITORIO = 'landscape',
    MAPA_ESTILOS_ELEMENTO_TERRITORIO_URBANO = 'landscape.man_made',
    MAPA_ESTILOS_ELEMENTO_TERRITORIO_NATURAL = 'landscape.natural',
    MAPA_ESTILOS_ELEMENTO_TERRITORIO_COBERTURA = 'landscape.natural.landcover',
    MAPA_ESTILOS_ELEMENTO_TERRITORIO_TERRENO = 'landscape.natural.terrain',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES = 'poi',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_TURISTICO = 'poi.attraction',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_COMERCIO = 'poi.business',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_ADMINISTRACION = 'poi.government',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_MEDICO = 'poi.medical',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_PARQUE = 'poi.park',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_RELIGIOSOS = 'poi.place_of_worship',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_EDUCACION = 'poi.school',
    MAPA_ESTILOS_ELEMENTO_PUNTODEINTERES_DEPORTIVO = 'poi.sports_complex',
    MAPA_ESTILOS_ELEMENTO_CARRETERAS = 'road',
    MAPA_ESTILOS_ELEMENTO_CARRETERAS_ARTERIAL = 'road.arterial',
    MAPA_ESTILOS_ELEMENTO_CARRETERAS_AUTOPISTAS = 'road.highway',
    MAPA_ESTILOS_ELEMENTO_CARRETERAS_AUTOPISTAS_PEAJE = 'road.highway.controlled_access',
    MAPA_ESTILOS_ELEMENTO_CARRETERAS_LOCALES = 'road.local',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO = 'transit',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO_LINEAS = 'transit.line',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO_ESTACIONES = 'transit.station',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO_ESTACIONES_AEROPUERTO = 'transit.station.airport',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO_ESTACIONES_AUTOBUS = 'transit.station.bus',
    MAPA_ESTILOS_ELEMENTO_TRANSPORTE_PUBLICO_ESTACIONES_TREN = 'transit.station.rail',
    MAPA_ESTILOS_ELEMENTO_AGUA = 'water',
  }
  
  export enum mapaEstilosVisibleEnum {
      MAPA_ESTILOS_VISIBLE_SI = 'on',
      MAPA_ESTILOS_VISIBLE_NO = 'off',
      MAPA_ESTILOS_VISIBLE_SIMPLIFICADO = 'simplified'
  }
  
  export enum zoomControlEnum {
    SMALL = 'SMALL',
    LARGE = 'LARGE'
  }
  
  export interface IEstilosConfig {
    elemento: string,
    tipo: tiposEstilosEnum,
    color: string,
  }
  // export interface IMapaDirecciones {
  //   longitud: string,
  //   latitud: string,
  //   tipo: tiposEstilosEnum,
  //   color: string,
  // }
  export interface IEstilosPropiedadConfig {
    elemento: string,
    tipo: string,
    visible?: boolean,
    color?: string,
    gamma?: number,
    matiz?: string,
    brillo?: number,
    invertirBrillo?: boolean,
    saturacion?: number,
    grosor?: number
  }

  export const DEMO_DIRECCIONES = [
    {
      direccion: 'Mendaña de Neyra 26 Bajo, 15008 A Coruña',
      iconoMarker: 'map-marker-neg.svg'
    },
    {
      direccion: 'Betanzos',
      iconoMarker: 'map-marker.svg'
    },
    {
      direccion: 'Ferrol',
      iconoMarker: 'map-marker.svg'
    },
    {
      direccion: 'As Pontes',
      iconoMarker: 'map-marker.svg'
    },
  ];

  export const DEMO_ESTILOS = [
    {
      elemento: 'all',
      tipo: 'all',
      saturacion: -100,
    },
    {
      elemento: 'water',
      tipo: 'all',
      color: '#f3997b'
    }
  ]